import * as React from "react";
import * as ReactDOM from "react-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { lightBlue, amber } from "@material-ui/core/colors";
import { Login } from "./components/Login";
import { BRANDING_THEMES } from "./consts";
import { TBrandingTheme } from "./types";
import { Api } from "./api/api";


const theme: any = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    secondary: amber,
    primary: lightBlue,
    type: "dark"
  }
});

export default function RimLogin(args: any) {
  const [branding, setBranding] = React.useState<TBrandingTheme>({} as TBrandingTheme);

  React.useEffect(() => {
    applyBranding();
  }, []);

  const applyBranding = async () => {
    let brandingTheme = BRANDING_THEMES.radiflow;

    try {
      const { data: { branding: { name: brandingName } } } = await Api.getBranding();

      brandingTheme = BRANDING_THEMES[brandingName] || BRANDING_THEMES.radiflow;
    } catch (error) {
      console.error('Failed to get branding', error);
    }

    const faviconElement = document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');

    if (faviconElement) {
      faviconElement.href = `images/${brandingTheme.name}/favicon.ico`;
    }

    setBranding(brandingTheme);
  };

  return (
    <MuiThemeProvider theme={theme}>
      <Login
        backgroundUrl="images/login-background-empty.jpg"
        logoUrl={branding.name && `images/${branding.name}/logo.png`}
        productName="RIM"
      />
    </MuiThemeProvider>
  );
}

ReactDOM.render(<RimLogin />, document.getElementById("login"));
